export default {
  namespaced: true,

  state: {
    messagingFlag: false,
    aiDocTypeDetectionAndExtractionFlag: false,
    pendoTrackingFlag: false,
  },

  getters: {
    messagingFlag: state => state.messagingFlag,
    aiDocTypeDetectionAndExtractionFlag: state => state.aiDocTypeDetectionAndExtractionFlag,
    pendoTrackingFlag: state => state.pendoTrackingFlag,
  },

  mutations: {
    mutateMessagingFlag: (state, messagingFlag) => (state.messagingFlag = messagingFlag),
    mutateAiDocTypeDetectionAndExtractionFlag: (state, aiDocTypeDetectionAndExtractionFlag) =>
      (state.aiDocTypeDetectionAndExtractionFlag = aiDocTypeDetectionAndExtractionFlag),
    mutatePendoTrackingFlag: (state, pendoTrackingFlag) => (state.pendoTrackingFlag = pendoTrackingFlag),
  },

  actions: {
    updateMessagingFlag({ commit }, value) {
      commit("mutateMessagingFlag", value);
    },

    updateAiDocTypeDetectionAndExtractionFlag({ commit }, value) {
      commit("mutateAiDocTypeDetectionAndExtractionFlag", value);
    },

    updatePendoTrackingFlag({ commit }, value) {
      commit("mutatePendoTrackingFlag", value);
    },
  },
};
